import React from "react";
import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import { MdConstruction } from "react-icons/md";
import Colors from "../../assets/styles/Colors";

export default function WeeklyNotificationsView() {
  return (
    <Box sx={{ width: "100%", py: 3 }}>
      <Container maxWidth="xl">

        {/* Header */}
        <Paper sx={{ mb: 3, p: 2.5, borderRadius: 3, background: `linear-gradient(135deg, ${Colors.bgSecondary} 0%, ${Colors.bgTertiary} 100%)`, border: `1px solid ${Colors.borderSecondary}` }}>
          <Typography variant="h5" sx={{ color: Colors.textPrimary }}>Notificaciones Semanales</Typography>
          <Typography variant="body2" sx={{ color: Colors.textSecondary, mt: 0.5 }}>
            Gestión de notificaciones automáticas semanales
          </Typography>
        </Paper>

        {/* Under construction card */}
        <Paper sx={{ p: 6, borderRadius: 3, backgroundColor: Colors.bgSecondary, border: `1px solid ${Colors.borderSecondary}`, textAlign: "center" }}>
          <Stack alignItems="center" spacing={2}>
            <Box sx={{ color: Colors.textSecondary, opacity: 0.5 }}>
              <MdConstruction size={48} />
            </Box>
            <Typography variant="h6" sx={{ color: Colors.textPrimary }}>
              Sección en construcción
            </Typography>
            <Typography variant="body2" sx={{ color: Colors.textSecondary, maxWidth: 400 }}>
              Las notificaciones semanales automáticas estarán disponibles próximamente.
            </Typography>
          </Stack>
        </Paper>

      </Container>
    </Box>
  );
}
